// Engagement tiers computed from a composite activity score.
//
// Backed by
//   GET /api/groups/{groupId}/members/engagement
// returning, per member: { userId, contributions, campaignsJoined,
//   messagesCount, reactionsGiven, postsShared, score }
// where score is a 0-100 composite the backend computes from:
//   contributions (normalised) + campaignsJoined + messagesCount
//   + reactionsGiven + postsShared, weighted.
// The endpoint is restricted to active group members, and anonymous
// contributions are excluded from `contributions`.
// If the request is rejected, members.store.js falls back to `tier: null`
// and MemberCard.vue simply omits the badge — see fetchMembers() there.
//
// Icons must exist in the F7 Icons font: `trophy_fill` renders blank there, so
// the top tier uses the award rosette instead.
export const ENGAGEMENT_TIERS = [
  { code: 'PILIER',       label: 'member.tier.pilier',       minScore: 80, icon: 'rosette',           color: '#C9A84C' },
  { code: 'CONTRIBUTEUR', label: 'member.tier.contributeur', minScore: 50, icon: 'star_fill',         color: '#97C459' },
  { code: 'ACTIF',        label: 'member.tier.actif',        minScore: 20, icon: 'bolt_fill',         color: '#185FA5' },
  { code: 'NOUVEAU',      label: 'member.tier.nouveau',      minScore: 0,  icon: null,                color: null },
]

export function tierForScore(score) {
  if (score == null) return null
  return ENGAGEMENT_TIERS.find(t => score >= t.minScore) ?? ENGAGEMENT_TIERS.at(-1)
}